import { Button, Modal } from 'react-bootstrap';

export default function ConfirmationPopup({
  showConfirmationModal,
  setShowConfirmationModal,
  isLoading,
  onProcced,
  selectedAgentIdCheck
}) {
  // Custom colors
  const primaryColor = '#055837';
  const secondaryColor = '#FFCC01';

  return (
    <>
      {/* Delete Confirmation Modal */}
      <Modal 
        show={showConfirmationModal}
        onHide={() => setShowConfirmationModal(false)}
        animation={false}
        backdrop="static"
        centered
        size="lg"
      >
        <Modal.Header style={{
          backgroundColor: secondaryColor,
          color: primaryColor
        }}>
          <Modal.Title className='mx-auto d-block'>
            <h5 className="modal-title text-uppercase"><b>Confirmation</b></h5>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="row">
            <div className="col-12 text-center" style={{fontWeight: 'bold', fontSize: 15}}>
              <h5>
                Are you sure you want to {(selectedAgentIdCheck) ? "activate" : "deactivate"} Team Member Module?
              </h5>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer className="d-flex justify-content-center">
          <Button
            variant="light"
            className="me-3"
            onClick={() => {setShowConfirmationModal(false)}}
            onMouseEnter={(e) => (e.target.style.transform = "scale(1.02)")}
            onMouseLeave={(e) => (e.target.style.transform = "scale(1)")}
          >
            Cancel
          </Button>
          <Button
            className="btn_green_yellow"
            style={{
              backgroundColor: primaryColor,
              color: secondaryColor,
              transition: "transform 0.2s",
            }}
            onClick={() => {onProcced()}}
            disabled={isLoading}
            onMouseEnter={(e) => (e.target.style.transform = "scale(1.02)")}
            onMouseLeave={(e) => (e.target.style.transform = "scale(1)")}
          >
            {isLoading ? 'Confirming...' : 'Confirm'}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  )
}
